"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gatsbyPluginTransitionLink = _interopRequireWildcard(require("gatsby-plugin-transition-link"));

var _gsap = require("gsap");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Cover =
/*#__PURE__*/
function (_Component) {
  _inherits(Cover, _Component);

  function Cover(_props) {
    var _this;

    _classCallCheck(this, Cover);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Cover).call(this, _props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "horizontal", function (_ref) {
      var node = _ref.node,
          seconds = _ref.props.length,
          direction = _ref.direction;
      var directionTo = direction === "left" ? "-100%" : "100%";
      var directionFrom = direction === "left" ? "100%" : "-100%";
      var wait = seconds / 6;
      var half = (seconds - wait) / 2;
      return new _gsap.TimelineMax().set(_this.cover, {
        y: 0,
        x: directionFrom,
        display: "block"
      }).to(_this.cover, half, {
        x: "0%",
        ease: _gsap.Power1.easeInOut
      }).set(node, {
        opacity: 0
      }).to(_this.cover, half, {
        x: directionTo,
        ease: _gsap.Power1.easeInOut
      }, "+=".concat(wait));
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "vertical", function (_ref2) {
      var node = _ref2.node,
          seconds = _ref2.props.length,
          direction = _ref2.direction;
      var directionTo = direction === "up" ? "-100%" : "100%";
      var directionFrom = direction === "up" ? "100%" : "-100%";
      var wait = seconds / 6;
      var half = (seconds - wait) / 2;
      return new _gsap.TimelineMax().set(_this.cover, {
        y: directionFrom
      }).to(_this.cover, half, {
        y: "0%",
        ease: _gsap.Power1.easeInOut
      }).set(node, {
        opacity: 0
      }).to(_this.cover, half, {
        y: directionTo,
        ease: _gsap.Power1.easeIn
      }, "+=".concat(wait));
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "moveInDirection", function (_ref3) {
      var props = _ref3.props,
          direction = _ref3.direction,
          node = _ref3.node;
      if (direction === "left" || direction === "right") return _this.horizontal({
        props: props,
        direction: direction,
        node: node
      });
      return _this.vertical({
        props: props,
        direction: direction,
        node: node
      });
    });

    _this.horizontal = _this.horizontal.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.vertical = _this.vertical.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.cover = _react.default.createRef();
    return _this;
  }

  _createClass(Cover, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var direction = this.props.direction || "left";
      var length = this.props.length || 1;
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_gatsbyPluginTransitionLink.default, {
        to: this.props.to,
        exit: {
          length: length,
          trigger: function trigger(_ref4) {
            var exit = _ref4.exit,
                node = _ref4.node;
            return _this2.moveInDirection({
              props: exit,
              node: node,
              direction: direction
            });
          }
        },
        entry: {
          delay: length / 2
        }
      }, this.props.children), _react.default.createElement(_gatsbyPluginTransitionLink.TransitionPortal, null, _react.default.createElement("div", {
        ref: function ref(n) {
          return _this2.cover = n;
        },
        style: {
          position: "fixed",
          background: this.props.bg || "#4b2571",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          transform: "translateY(100%)"
        }
      })));
    }
  }]);

  return Cover;
}(_react.Component);

exports.default = Cover;